import '../css/infowindow.css'
import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Header, Loader, Icon, Image, Item } from 'semantic-ui-react'
// import Disqus from 'disqus-react';


export class InfoWindow extends Component {

	constructor() {
		super();
		this.state = {
			hidden: false
		}
	}
	renderHTMLString(a) {
		return { __html: a };
	}

	componentWillReceiveProps() {
		this.setState({ hidden: true });
	}

	componentDidUpdate() {
		// delay rendering of comments
		if (this.state.hidden) {
			setTimeout(() => this.setState({ hidden: false }), 1000)
		}
	}


	render() {

		if (!this.props.state.data.length) {
			return (
				<div id="infowindow">
					<Loader active>cargando...</Loader>
				</div>
			)
		}


		var a = this.props.state.data.find((item) => {
			return this.props.match.params.path == item.path
		});

		if (a === undefined) {
			return (
				<div id="infowindow">

					<h1>La página que estás buscando no es disponible.</h1>

					<h3>¿Te has perdido? <Link to={"/"}>Vuelve al Mapa</Link></h3>
				</div>
			)
		} else {


			return (

				<div id="infowindow">

					<div id="info-nav">
						<div>
							<Link style={{ marginRight: "1rem" }} to={this.getLink(a, -1)}><Icon name='left arrow' />Anterior</Link>
							<Link style={{ marginRight: "1rem" }} to={this.getLink(a, 1)}>Siguiente <Icon name='right arrow' /></Link>
						</div>
						<Link to="/">Listado<Icon name='up arrow' /></Link>
					</div>


					<div id="info-container">

						<Item id="info-text">

							<Item.Content>
								<Item.Header as='h2' style={{ marginBottom: "2rem" }}>{a.name}</Item.Header>
								<Item.Description>
									<p dangerouslySetInnerHTML={this.renderHTMLString(a.descrizione)} ></p>
								</Item.Description>
								<Item.Extra id="info-meta">
									{a.indirizzo && a.indirizzo !== "-" && <p>{a.indirizzo}</p>}
									{a.web && a.web !== "-" && <p>web: <a target="_blank" href={a.web}>{a.web}</a></p>}
									{a.email && a.email && <p>email: <a href={"mailto:" + a.email}>{a.email}</a></p>}
									{a.telefono && a.telefono && <p>tel: <a href={"tel:" + a.telefono}>{a.telefono}</a></p>}
								</Item.Extra>
							</Item.Content>
						</Item>

						<div id="info-img" style={{ backgroundImage: `url(${a.immagine})` }}>
						</div>

					</div>


				</div>
			)
		}

	}

	getLink(currentItem, n) {
		var index = -1;

		index = this.props.state.currentData.indexOf(currentItem);
		index += n;
		if (index < 0) {
			index = this.props.state.currentData.length - 1;
		} else if (index > this.props.state.currentData.length - 1) {
			index = 0;
		}
		return "" + this.props.state.currentData[index].path;
	}
};


export default InfoWindow;



// WEBPACK FOOTER //
// ./src/infowindow/InfoWindow.js